import { createContext, useContext } from 'react';

const SessionRuntimeContext = createContext(null);

export function SessionRuntimeProvider({ session, children }) {
  return (
    <SessionRuntimeContext.Provider value={session || null}>
      {children}
    </SessionRuntimeContext.Provider>
  );
}

export function useSessionRuntimeSession() {
  return useContext(SessionRuntimeContext);
}
